import React from "react";
import { object, string } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import CardImage from "../../atoms/CardImage";

import "./tiny-card.m.css";

const TinyCard = ({ collection, story, className = "" }) => {
  return (
    <div className={className} styleName="base">
      <div styleName="container">
        <CardImage
          story={story}
          imageType="image96x35"
          aspectRatio={[96, 35]}
          showStoryTypeIcon={false}
          widths={[290, 280, 320]}
          styleName="bg-image"
        />
        <div styleName="content">
          {collection && (
            <CollectionTitleWithArrow
              styleName="collection-title-tiny"
              border={false}
              collection={collection}
              disableArrow={true}
            />
          )}
          <NewsHeadline showSubHeading={false} story={story} iconEnd={true} />
        </div>
      </div>
    </div>
  );
};

TinyCard.propTypes = {
  className: string,
  collection: object,
  story: object,
};

export default TinyCard;
